import { lazy } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { HumanTaskAppVariant } from './Agents/Flows/HumanTasks/types';
import { NotFoundPage } from './NotFoundPage';
import { LazyLoader } from '../components/LazyLoader';

const HumanTaskRoutes = lazy(() =>
  import('./Agents/Flows/HumanTasks/Routes').then((module) => ({ default: module.HumanTaskRoutes }))
);

export function CopilotRoutes() {
  const match = useRouteMatch();
  return (
    <LazyLoader>
      <Switch>
        <Route path={`${match.path}/humanTasks`}>
          <HumanTaskRoutes appVariant={HumanTaskAppVariant.CopilotApp} />
        </Route>
        <Route path="*" component={NotFoundPage} />
      </Switch>
    </LazyLoader>
  );
}
